import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/gmail.vue
var o = {
	name: "DtIconGmail",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--gmail"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Gmail",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("<path d=\"M6.545 20.004v-7.727L4.15 10.084 2 8.867v9.773c0 .755.611 1.364 1.364 1.364h3.181z\" fill=\"#4285F4\"></path><path d=\"M17.454 20.004h3.182c.755 0 1.364-.612 1.364-1.364V8.868l-2.434 1.393-2.111 2.016v7.727z\" fill=\"#34A853\"></path><path d=\"m6.545 12.277-.326-3.02.326-2.89L12 10.458l5.454-4.09.365 2.733-.364 3.176L12 16.367l-5.455-4.09z\" fill=\"#EA4335\"></path><path d=\"M17.454 6.367v5.91L22 8.867V7.05c0-1.686-1.925-2.647-3.273-1.636l-1.273.954z\" fill=\"#FBBC04\"></path><path d=\"m2 8.867 2.09 1.568 2.455 1.841V6.368l-1.272-.954C3.923 4.4 2 5.363 2 7.049v1.818z\" fill=\"#C5221F\"></path>", 5)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=gmail.js.map